/* eslint-disable no-extra-boolean-cast */
// import { unwrapResult } from '@reduxjs/toolkit';
// import { useAppDispatch } from 'app/hooks';
import { AppRouteType, delayLazyLoad } from 'layouts/helper';
import PrivateLayout from 'layouts/PrivateLayout';
import getRoutePrivate from 'layouts/PrivateLayout/getRoutePrivate';
import PublicLayout from 'layouts/PublicLayout';
import getRoutePublic from 'layouts/PublicLayout/getRoutePublic';
import routesMap from 'layouts/routesMap';
import PageLoader from 'components/PageLoader';
import React, { lazy, useEffect, useMemo } from 'react';
// import { useDispatch } from 'react-redux';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
// import { actionGetToken } from 'redux/auth/actions';
// import { sourceApp, versionApp } from 'utils/constants';
// import { getStorageData, setStorageData, STORAGE_KEY } from 'utils/storage';
import { getStorageData, STORAGE_KEY } from 'utils/storage';

const Page404 = lazy(() => delayLazyLoad(import('components/Page404')));
const AdminLoginPage = lazy(() => import('pages/AdminTinTuc/AdminLoginPage'));
const AdminArticlesPage = lazy(() => import('pages/AdminTinTuc'));
const AdminArticleNewPage = lazy(() => import('pages/AdminTinTuc/NewArticlePage'));
const AdminArticleEditPage = lazy(() => import('pages/AdminTinTuc/EditArticlePage'));

const AdminGuard: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  const isLogged = Boolean(getStorageData(STORAGE_KEY.ACCESS_TOKEN));

  if (!isLogged) {
    return <Navigate to={routesMap.ADMIN_LOGIN} replace state={{ from: location.pathname }} />;
  }

  return children;
};

const makeRoutes = (routes: AppRouteType[]): JSX.Element[] => {
  return routes.map((route, idx) => {
    const { component: PageComponent } = route;
    return <Route key={idx} path={route.path} element={<PageComponent />} />;
  });
};

const AppContainer: React.FC = () => {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const dispatch = useDispatch<any>();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get('code');
  // const username = urlParams.get('username');

  // async function getToken(): Promise<void> {
  //   const payload = {
  //     username: username || '',
  //     source: sourceApp,
  //     token: code || '',
  //     version: versionApp,
  //   }
  //   const response = await dispatch(actionGetToken(payload));
  //   const res = unwrapResult(response);
    
  //   setStorageData(STORAGE_KEY.ACCESS_TOKEN, res.data.token);
  //   setStorageData(STORAGE_KEY.USER_INFO, res.data.data);
  //   window.location.href = window.location.origin
  // }

  // async function getShareCode(): Promise<void> {
  //   const response = await dispatch(actionGetShareCode());
  //   const res = unwrapResult(response);
  // }

  //fake token
  // useEffect(() => {
  //   setStorageData(STORAGE_KEY.ACCESS_TOKEN, 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOjIsInBob25lIjoiMDk2ODYyNjIyMiIsInNyYyI6MSwibmFtZSI6Ik5ndXnhu4VuIFbEg24gRGV2IiwiZXhwIjoxNjYwMzI1NDkxOTA5LCJpYXQiOjE2NjAyMzkwOTE5MTAsInRva2VuIjoiR1lLTTdsdVZhS1ZoOGJUdjJuRDhWZGJuby9OSDNKZU1xKzIzK2Y2OXpsST0iLCJ1c2VybmFtZSI6ImRldnZpcCJ9.DCJafHH9TKpu3QYV6JMFFuGk4uZEHWHOTf2otWDV6KoTg8uHyxVtevyIIlhK31lVDjL1ugJNMDMl4QUC1hKyB9mFCAorZCHqiO-3Xt8ulOzMoNW9ZQ7vZDY9Yrjq0RGWG047At1sB-VcZtGQr54aVu27NIhZ_o4V0BrbwzPQf66mQxdAbTrUCALu_c6VWL6HjQt9kEQvx144RDlYTjZVRiIPtE62onyV88tWWSn0yjR83dH3lWwDWZgxT-0OX7NfNKB-9UEg79SY1b_zalpPCCPO3DP7V120EakE_SuA0WmIsNYTF6thU5uY8QK5ORcGUex1HSypS-6B-N2FLortqA');
  // },[])
  //--------------------------------

  // useEffect(() => {
  //   const token = getStorageData<string>(STORAGE_KEY.ACCESS_TOKEN);
  //   if(!!code){
  //     if (!token){
  //       getToken()
  //     } else {
  //       window.location.href = window.location.origin
  //     }
  //   }
  //   // getShareCode()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[code])

  const routePrivate = useMemo(() => {
    return getRoutePrivate();
  }, []);

  const routePublic = useMemo(() => {
    return getRoutePublic();
  }, []);

  // Prefetch tất cả public page chunks sau khi app mount
  // → khi user click nav, chunk đã cache → không trigger Suspense → không blank
  useEffect(() => {
    Promise.allSettled([
      import('pages/HomePage'),
      import('pages/GioiThieu'),
      import('pages/TinTuc'),
      import('pages/TinTuc/TinTucNganhPage'),
    ]);
  }, []);

  return (
    <React.Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route path={routesMap.ADMIN_LOGIN} element={<AdminLoginPage />} />
          <Route
            path={routesMap.ADMIN}
            element={(
              <AdminGuard>
                <Navigate to={routesMap.ADMIN_TIN_TUC} replace />
              </AdminGuard>
            )}
          />
          <Route
            path={routesMap.ADMIN_TIN_TUC}
            element={(
              <AdminGuard>
                <AdminArticlesPage />
              </AdminGuard>
            )}
          />
          <Route
            path={routesMap.ADMIN_TIN_TUC_NEW}
            element={(
              <AdminGuard>
                <AdminArticleNewPage />
              </AdminGuard>
            )}
          />
          <Route
            path={routesMap.ADMIN_TIN_TUC_EDIT}
            element={(
              <AdminGuard>
                <AdminArticleEditPage />
              </AdminGuard>
            )}
          />

          {/* Public routes */}
          <Route element={<PublicLayout />}>{makeRoutes(routePublic)}</Route>

          {/* Private route */}
          <Route element={<PrivateLayout code={code} />}>{makeRoutes(routePrivate)}</Route>

          {/* Catch all */}
          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
    </React.Suspense>
  );
};

export default AppContainer;
